<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="primary"
        pill
        @click="createUser"
        v-if="hasPermission('create_user')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Create</span>
      </b-button>
    </div>
    <b-card>
      <h1>User Management</h1>
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Name"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input id="name" v-model="name" placeholder="Name" />
            </b-form-group>
            <b-form-group
              label="Username"
              label-for="username"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-form-input
                id="username"
                v-model="username"
                placeholder="Username"
              />
            </b-form-group>
            <b-form-group
              class="w-50"
              v-if="searchType.value === 3"
            >
              <VueSelectPaginated
                placeholder="Role"
                name="Role"
                label="name"
                rules="required"
                searchBy="name"
                :getListMethod="getRoles"
                @setMethod="
                  (value) => {
                    role = value;
                  }
                "
              />
            </b-form-group>

            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 4"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 5"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Floor"
              label-for="floor"
              class="w-50"
              v-if="searchType.value === 6"
            >
              <v-select
                label="name"
                v-model="floor"
                placeholder="Select Floor"
                :options="floors"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              class="w-50"
              v-if="searchType.value === 7"
            >
              <b-form-input id="email" type="email" v-model="email" placeholder="Email" />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="users"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_user')"
        :per-page="0"
        :tbody-tr-class="rowClass"
      > 
        <template #cell(username)="row">
          <b-link @click="row.toggleDetails">
            {{
              row.item.username ? row.item.username : ""
            }}
          </b-link>
        </template>

        <template #row-details="row">
          <b-card bg-variant="light" border-variant="dark">
            <b-table
              responsive="sm"
              :fields="user_flats_fields"
              :items="row.item.user_flats_data"
              details-td-class="m-0 p-0"
              small
            >

            <template #cell(user_data)="row">
              {{ row.item.user_data ? row.item.user_data.name : "" }} - {{ row.item.user_data ? row.item.user_data.mobile_number : "" }}
            </template>        

            <template #cell(floor_data)="row">
              {{ row.item.floor_data ? row.item.floor_data.building : "" }} - {{ row.item.floor_data ? row.item.floor_data.name : "" }}
            </template>        
            
            <template #cell(flat_data)="row">
              {{ row.item.flat_data ? row.item.flat_data.name : "" }}
            </template>        

            <template #cell(is_approved)="row">
              <b-badge :variant="badgeVariantUserFlats(row.item.is_approved)">
                {{ row.item.is_approved === null ? 'Pending' : (row.item.is_approved ? 'Approved':'Rejected') }}
              </b-badge>
            </template>

            <template #cell(manage)="row">
              <b-dropdown pill  size="sm"  text="Change Status" variant="info" class="" v-if="hasPermission('update_user')">
                <b-dropdown-item :hidden="row.item.is_approved === true ? true:false" @click="changeStatusUserFlats(row.item, true)">Approve</b-dropdown-item>
                <b-dropdown-item :hidden="row.item.is_approved === false ? true:false" @click="changeStatusUserFlats(row.item, false)">Reject</b-dropdown-item>
                <b-dropdown-item :hidden="row.item.is_approved === null ? true:false" @click="changeStatusUserFlats(row.item, null)">Pending</b-dropdown-item>
              </b-dropdown>
            </template>

            </b-table>
          </b-card>
        </template>

        <template #cell(role_data)="row">
          {{ row.item.role_data ? row.item.role_data.name : "" }}
        </template>        
        <template #cell(profile_status)="row">
          <b-badge :variant="badgeVariant(row.item.profile_status)">
            {{ row.item.profile_status }}
          </b-badge>
        </template>
        <template #cell(has_pending_flats)="row">
          {{ row.item.has_pending_flats ? 'Yes' : 'No' }}
        </template>  
        
        <template #cell(manage)="row">
          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="editUser(row.item)"
            v-if="hasPermission('update_user')"
          >
            Edit
          </b-button>

          <b-dropdown pill size="sm" :hidden="row.item.profile_status != 'Pending' ? true:false"  text="Change Status" variant="info" class="" v-if="hasPermission('update_user')">
            <b-dropdown-item :hidden="row.item.profile_status === 'Approved' ? true:false" @click="changeStatus(row.item, 'Approved')">Approve</b-dropdown-item>
            <b-dropdown-item :hidden="row.item.profile_status === 'Rejected' ? true:false" @click="changeStatus(row.item, 'Rejected')">Reject</b-dropdown-item>
            <!-- <b-dropdown-item :hidden="row.item.profile_status === 'Pending' ? true:false" @click="changeStatus(row.item, 'Pending')">Pending</b-dropdown-item> -->
            <!-- <b-dropdown-item :hidden="row.item.profile_status === 'Left' ? true:false" @click="changeStatus(row.item, 'Left')">Left</b-dropdown-item> -->
          </b-dropdown>
        </template>
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>



    <CreateUserModal
      @modalClosed="onModalClosed"
      :key="`create-${createUserModalCount}`"
    />
    <EditUserModal
      :user="user"
      @modalClosed="onModalClosed"
      :key="`edit-${editUserModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateUserModal from "@/components/user/CreateUserModal.vue";
import EditUserModal from "@/components/user/EditUserModal.vue";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    CreateUserModal,
    EditUserModal,
    VueSelectPaginated,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Full Name" },
        { key: "username", label: "Username" },
        { key: "email", label: "Email" },
        { key: "role_data", label: "Role" },
        { key: "profile_status", label: "Status" },
        { key: "has_pending_flats", label: "Pending List" },
        { key: "manage", label: "Manage" },
      ],
      user_flats_fields: [
        { key: "user_data", label: "User" },
        { key: "floor_data", label: "Floor" },
        { key: "flat_data", label: "Flat" },
        { key: "user_type", label: "User Type" },
        { key: "is_approved", label: "Status" },
        { key: "arrival_time", label: "Arrival" },
        { key: "departure_time", label: "Departure" },
        { key: "manage", label: "Action" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      users: [],
      user: null,
      createUserModalCount: 0,
      editUserModalCount: 0,
      searchTypes: [
        { value: 1, name: "Name" },
        { value: 2, name: "Username" },
        { value: 3, name: "Role" },
        { value: 4, name: "Site" },
        { value: 5, name: "Building" },
        { value: 6, name: "Floor" },
        { value: 7, name: "Email" },
      ],
      searchType: null,
      name: "",
      username: "",
      role: "",

      sites: [],
      buildings: [],
      floors: [],
      site: "",
      building: "",
      floor: "",
      email: "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;

    const floors = await this.getFloorsDDL();
    this.floors = floors.data;
  },
  methods: {
    ...mapActions({
      getUsers: "appData/getUsers",
      deleteUser: "appData/deleteUser",
      updateUser: "appData/updateUser",
      getRoles: "appData/getRoles",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
      updateFlatUser: "appData/updateFlatUser",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.username = "";
            this.role="";
            this.site="";
            this.building="";
            this.floor="";
            this.email="";
            break;
          case 2:
            this.name = "";
            this.role = "";
            this.site="";
            this.building="";
            this.floor="";
            this.email="";
            break;
          case 3:
            this.name = "";
            this.username = "";
            this.site="";
            this.building="";
            this.floor="";
            this.email="";
            break;
          case 4:
            this.name = "";
            this.username = "";
            this.role = "";
            this.building="";
            this.floor="";
            this.email="";
            break;
          case 5:
            this.name = "";
            this.username = "";
            this.role = "";
            this.site="";
            this.floor="";
            this.email="";
            break;
          case 6:
            this.name = "";
            this.username = "";
            this.role = "";
            this.site="";
            this.building="";
            this.email="";
            break;
          case 7:
            this.name = "";
            this.username = "";
            this.role = "";
            this.site="";
            this.building="";
            this.floor="";
            break;
        }
      } else {
        this.name = "";
        this.username = "";
        this.role = "";
        this.site="";
        this.building="";
        this.floor="";
        this.email="";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getUsers({
          pageNumber: this.currentPage,
          name: this.name,
          username: this.username,
          role: this.role,
          site: this.site,        
          building: this.building,
          floor: this.floor,
          email: this.email,
        });
        this.users = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    badgeVariant(status) {
      switch (status) {
        case 'Approved':
          return 'success';
        case 'Rejected':
          return 'danger';
        case 'Pending':
          return 'warning';
        case 'Left':
          return 'dark';
        default:
          return 'light';
      }
    },
    badgeVariantUserFlats(status) {
      switch (status) {
        case true:
          return 'success';
        case false:
          return 'danger';
        case null:
          return 'warning';
        
        default:
          return 'light';
      }
    },
    createUser() {
      this.createUserModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-user-modal");
      });
    },
    editUser(user) {
      this.user = user;
      this.editUserModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-user-modal");
      });
    },
    async changeStatus(data, profile_status){      
      try {
        const formData = new FormData();
        formData.append("profile_status", profile_status);        
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateUser({
          payload: formData,
          pk: data.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Status Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();          
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async changeStatusUserFlats(data, status){      
      try {
        const formData = new FormData();
        formData.append("is_approved", status);        
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateFlatUser({
          payload: formData,
          pk: data.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Status Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();          
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async removeUser(user) {
      this.user = user;
      try {
        const res = await this.deleteUser({
          pk: this.user.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "User deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.profile_status === 'Pending' || item.has_pending_flats === true) return 'table-warning'
    },
  },
  computed: {
    ...mapGetters({ hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser" },
    ),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style scoped>
.amber-background {
  background-color: #ffbf00 !important;
}
</style>

